import { useMemo } from 'react';
import cn from 'classnames';
import { Sector } from '@/finsight/ui/components/deals/DealListTable/cells/Sector';
import { Status } from '@/finsight/ui/components/deals/DealListTable/cells/Status';
import { DealName } from '@/finsight/ui/components/deals/DealListTable/cells/DealName';
import { ParentCompany } from '@/finsight/ui/components/deals/DealListTable/cells/ParentCompany';
import { Region } from '@/finsight/ui/components/deals/DealListTable/cells/Region';
import DealDateCell from '@/finsight/ui/common/components/TableCells/DealDateCell';
import { ProductAbbreviation } from '@/finsight/ui/components/deals/DealListTable/cells/ProductAbbrevation';
import { Leads } from '@/finsight/ui/components/deals/DealListTable/cells/Leads';
import Tools from '@/finsight/ui/components/deals/DealListTable/cells/Tools';
import { UpsizedDeal } from '@/finsight/ui/components/deals/DealListTable/cells/UpsizedDeal';
import { TriggerExpand } from '@/finsight/ui/components/deals/DealListTable/cells/TriggerExpand';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import spaceStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

interface IUseTableColumnsProps {
  setIsRowsExpanded: (isRowsExpanded: boolean) => void,
  isRowsExpanded: boolean,
}

export const useTableColumns = ({ setIsRowsExpanded, isRowsExpanded }: IUseTableColumnsProps) => {
  const columns = [
    {
      name: 'product',
      title: 'C/P',
      width: 55,
      className: alignStyles.alignCenter,
      cellCallback: ProductAbbreviation,
    },
    {
      name: 'sector',
      title: 'Sector',
      width: 70,
      className: alignStyles.alignCenter,
      cellCallback: Sector,
    },
    {
      name: 'upsized',
      width: 10,
      minWidth: 10,
      className: cn(alignStyles.alignLeft, spaceStyles.pn),
      cellCallback: UpsizedDeal,
    },
    {
      name: 'status',
      title: 'Status',
      width: 70,
      className: alignStyles.alignCenter,
      cellCallback: Status,
    },
    {
      name: 'primaryIssuer',
      title: 'Deal Name',
      width: 240,
      minWidth: 240,
      cellCallback: DealName,
    },
    {
      name: 'parent',
      title: 'Parent',
      width: 290,
      minWidth: 290,
      cellCallback: ParentCompany,
    },
    {
      name: 'leads',
      title: 'Leads',
      className: alignStyles.alignRight,
      minWidth: 150,
      cellCallback: Leads,
    },
    {
      name: 'region',
      title: 'Region',
      className: alignStyles.alignRight,
      width: 80,
      cellCallback: Region,
    },
    {
      name: 'expand',
      title: 'Date',
      className: alignStyles.alignRight,
      width: 110,
      minWidth: 110,
      cellCallback: DealDateCell,
    },
    {
      name: 'tools',
      title: <TriggerExpand setIsRowsExpanded={ setIsRowsExpanded } isRowsExpanded={ isRowsExpanded } />,
      className: alignStyles.alignCenter,
      width: 100,
      cellCallback: Tools,
    },
  ];

  return useMemo(
    () => columns,
    [setIsRowsExpanded, isRowsExpanded],
  );
};
